export default __webpack_public_path__ + "static/media/les_andelys08.4af8561b.jpg";